export const state = () => ({
	courses: null,
	cursor: null,
});

export const mutations = {
	setCourses(state: any, payload: any) {
		state.courses = payload;
	},

	setCursor(state: any, payload: any) {
		state.cursor = payload;
	},
};

export const getters = {
	getCourses: (state: any) => state.courses,
};

export const actions = {
	getCourses(state: any) {
		return new Promise((resolve, reject) => {
			let params = {
				cursor: state.state.cursor,
			};

			Object.keys(params).forEach((key) => !params[key] && delete params[key]);

			this.$axios
				.get('/api/courses', { params })
				.then((res) => {
					let courses;

					if (state.state.courses) {
						courses = JSON.parse(JSON.stringify(state.state.courses));
					}

					if (params.cursor) {
						courses.data.push(...res.data.data);
						courses.links = res.data.links;
						courses.meta = res.data.meta;
					} else {
						courses = res.data;
					}

					state.commit('setCourses', courses);

					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	recordsCourseView(state: any, course_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/courses/${course_uuid}/views`)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setCursor(state: any, payload: any) {
		state.commit('setCursor', payload);
	},
};
